// extracted by mini-css-extract-plugin
export default {"questionContainer":"QuestionContainer_questionContainer__j8CHh","title":"QuestionContainer_title__q9Woa"};